import React from 'react';
import { Button } from '../../../components/ui/button';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription,
} from '../../../components/ui/dialog';

export const ETIQUETAS_SIN_PREGUNTA = ['bot', 'en_curso', 'cerrada'];

export const CRMSalirDialog = ({ open, phone, onConfirm, onSkip }) => (
  <Dialog open={open} onOpenChange={(o) => { if (!o) onSkip(); }}>
    <DialogContent data-testid="crm-dialog-salir">
      <DialogHeader>
        <DialogTitle>¿Pasar a "En curso"?</DialogTitle>
        <DialogDescription>
          Leíste la conversación con <span className="font-mono">{phone}</span>. ¿Querés cambiar su estado a "En curso"?
        </DialogDescription>
      </DialogHeader>
      <DialogFooter className="gap-2">
        <Button variant="outline" onClick={onSkip} data-testid="crm-salir-dejar">Dejar como está</Button>
        <Button onClick={onConfirm} data-testid="crm-salir-en-curso">Pasar a En curso</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
